var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1125 18.0062L24.9253 38.118L13.9946 28.2467L16.0053 26.0202L24.711 33.8822L40.8874 15.994L43.1125 18.0062Z",
    fill: "#ECEEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5285 52.572C26.0601 53.7668 19.3815 52.3641 13.9403 48.668C8.49911 44.9719 4.73382 39.2804 3.46059 32.827C2.18736 26.3736 3.5088 19.6784 7.13846 14.1927C10.7681 8.70702 16.4135 4.87285 22.851 3.52129C29.2884 2.16974 35.9991 3.40971 41.5285 6.97244C47.0579 10.5352 50.9604 16.1336 52.3901 22.5541C53.8198 28.9746 52.6615 35.7 49.1662 41.2722C45.6709 46.8445 40.1204 50.8148 33.7177 52.3224L33.0596 49.5274C38.7269 48.193 43.6399 44.6787 46.7337 39.7464C49.8275 34.8142 50.8528 28.8613 49.5874 23.1782C48.3219 17.4951 44.8676 12.5397 39.9733 9.3862C35.079 6.23267 29.139 5.13511 23.441 6.33143C17.7429 7.52775 12.7459 10.9216 9.53314 15.7772C6.32037 20.6328 5.15071 26.559 6.27769 32.2712C7.40468 37.9833 10.7375 43.0212 15.5537 46.2928C20.37 49.5643 26.2815 50.8059 32.0069 49.7484L32.5285 52.572Z",
    fill: "#ECEEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7352 2.98914C34.0326 2.9255 40.1221 5.24098 44.7863 9.4727C49.4504 13.7044 52.3456 19.5406 52.8931 25.8145C53.4406 32.0884 51.6001 38.3378 47.7394 43.3135C43.8787 48.2891 38.2823 51.6244 32.069 52.6525L31.6084 49.8685C37.1204 48.9565 42.085 45.9977 45.51 41.5836C48.9349 37.1696 50.5677 31.6256 50.082 26.0598C49.5963 20.494 47.0279 15.3166 42.8902 11.5625C38.7525 7.80848 33.3503 5.75435 27.7637 5.8108L27.7352 2.98914Z",
    fill: "#22E295"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfVerified);
export default __webpack_public_path__ + "static/media/half-verified.54fbd300.svg";
export { ForwardRef as ReactComponent };